import { INTERNAL_V1, damRequest } from '@/hooks/damRequest';

// import { getSearchFacetsSchema } from '@/types/search';

const BASE = `${INTERNAL_V1}`;

export const getSearchFacets = async (params?: string, token?: string) => {
  const response = await damRequest('GET', `${BASE}/facets`, token);
  return response;

  //   return getDestinationsSchema.parse(response);
};
